import React from 'react';
import '../App.css';

function Demo() {
  return (
    <div className="App">
      <div className="container">
        {/* Header */}
        <header className="header">
          <h1 className="title">FieldOps</h1>
        </header>

        {/* Coming Soon Section */}
        <section className="section">
          <div className="highlight">
            <p>Demo is in development.</p>
          </div>
        </section>

        {/* Back to Home */}
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <a href="/" style={{ 
            color: '#64748b', 
            textDecoration: 'none', 
            fontSize: '1.1rem',
            fontWeight: '500'
          }}>
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}

export default Demo;